var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('v-main',[_c('v-container',{key:_vm.index,staticClass:"px-0 py-0",class:{ login: _vm.$route.name == 'login' },attrs:{"id":"route","fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }